import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=ca045766&scoped=true&"
import script from "./OrderReview.vue?vue&type=script&lang=js&"
export * from "./OrderReview.vue?vue&type=script&lang=js&"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=ca045766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca045766",
  null
  
)

export default component.exports